module.exports = __webpack_public_path__ + "static/media/Sandshrew_gaussian2.751f5f75.png";